import React from 'react';
import styled from 'styled-components';
import { media } from '../../styles/style-utils';
import { Logo } from './Logo';

const Wrapper = styled.div`
  display: flex;
  padding-left: var(--fr);
  padding-right: var(--fr);
  justify-content: center;
  ${media.mediumLarge`
    padding-left: calc(var(--fr) * 1.5);
    padding-right: calc(var(--fr) * 1.5);
  `};
`;

const Header = () => {
  return (
    <Wrapper>
      <Logo to="/">IDAGIO</Logo>
    </Wrapper>
  );
};

export default Header;



// WEBPACK FOOTER //
// /tmp/build_2cb81483/src/components/chrome/Header.js